import { Controller } from 'stimulus';

class PasswordRevealController extends Controller {
  connect() {
    this.isRevealed = false;
  }

  onTriggerClick() {
    this.isRevealed = !this.isRevealed;

    this.reveal();
  }

  reveal() {
    this.inputTarget.type = this.isRevealed ? 'text' : 'password';
    this.triggerTarget.classList.toggle('is-active', this.isRevealed);
  }
}

PasswordRevealController.targets = [
  'input',
  'trigger',
];

export default PasswordRevealController;
